@defer (when subscription()?.name) {
@if(subscription()) {
<div class="mt-4">
  <h5 class="text-center fw-normal">
    <p>We are thrilled to have you on board!</p>
    <p class="fst-italic">You will be receiving your first Farmbox on <strong>{{deliveryInfo()}}</strong></p>
  </h5>
  <div class="subscription-container">
    <img [src]="subscription()?.img" (error)="errorImage($event)" alt="">
    <section class="subscription-container__product-info">
      <p class="subscription-container__product-info__name">{{subscription()?.name}}</p>
    </section>
  </div>
  <div class="form-row-action mt-4 mb-4">
    <button type="button" class="btn btn-primary" (click)="goTo()">Start shopping</button>
  </div>
</div>
}
} @placeholder {
<div class="loading z-n1">
  <div class="loader">
    @for (item of [0,0,0,0,0]; track $index) {
    <div class="bg-secondary"></div>
    }
  </div>
</div>
}